<template>
  <div class="emoji-component" :style="'top:' + top + 'px;' + leftRight + ':'+(leftRight === 'right' ? 38 : 25 )+'px;'" :class="{'opened' : emojiVisible, 'circle': emojies.length === 1}">
    <div v-html="emoji.emoji_code" v-for="(emoji) in emojies" @click="addEmoji(emoji.id)" class="emoji-component-item">

    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import chatModule from "../../../chat/module/store/type";

export default {
    props: [],

    mixins: [
      require('@general/lib/mixin').default
    ],
    computed: {
        ...mapGetters({
          'emojies': 'availableEmojies'
        }),
    },
    methods: {
        ...mapActions({
        }),
      showModal(msg,index,conversation_key, context_menu){
        this.conversation_key = conversation_key;
        this.msg = msg;
        this.context_menu = context_menu;
        this.msg_index = index;
        let timeline = $('#msg-' + msg.id).find('.timeline');
        let timeline_height = timeline.length ? timeline.height() + 30 : 0; //30 - margin
        let emoji_container_height = $('.emoji-component').height();
        /*this.top = document.getElementById("msg-" + msg.id).getBoundingClientRect().top
            - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top
            + timeline_height
            - emoji_container_height
            - 10; //10px above message*/
        this.top = context_menu.top
            - $('#msg-' + msg.id).outerHeight()
            + timeline_height
            - emoji_container_height
            - 10;
        let chat_top = $('.conversation-screen')[0].getBoundingClientRect().top
            - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top
            + 10; //10px from conversation top
        let msg_top_changed = false;
        if(chat_top > this.top){
          this.top = chat_top;
          if($('#msg-' + msg.id).css('top') === '0px'){
            let msg_top = $('#msg-' + msg.id)[0].getBoundingClientRect().top - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top;
            let msg_from_emoji = msg_top - chat_top;
            let footer_textarea = document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().bottom
                - document.getElementsByClassName("conversation-screen")[0].getBoundingClientRect().top - 10; //10px from bottom screen
            let future_context_menu_top = (emoji_container_height + 10) + $('#msg-' + msg.id).outerHeight() + 10;
            if(future_context_menu_top + context_menu.height < footer_textarea){
              $('#msg-' + msg.id).css('top',(emoji_container_height - timeline_height - msg_from_emoji + 10) + 'px');
              context_menu.changeTop((emoji_container_height - timeline_height + 10) + $('#msg-' + msg.id).outerHeight() + 10)
              msg_top_changed= true;
            }else{
              this.top = context_menu.top - 100;
            }
          }else{
            this.top = context_menu.top - 100;
          }
        }
        this.leftRight = msg.user_from !== auth.getUserId() ? 'left' : 'right';
        let self = this;
        setTimeout(function (){
          self.emojiVisible = true;
          //setTimeout(function (){
            //self.width = self.emojies.length > 1 ? (24 * self.emojies.length + 20) : 35;
          //},20)
        },msg_top_changed ? 0 : 0) //0 coz we can start show emoji panel when message still is animated
      },
      hideEmojiModal(){
        this.width = 0;
        this.emojiVisible = false;
      },
      addEmoji(emoji_id){
        if(!this.msg.id){

          return false;
        }
        this.$store.dispatch(chatModule.actions.messages.addEmoji, {
          msg : this.msg,
          conversation_key : this.conversation_key,
          emoji: emoji_id,
          msg_index : this.msg_index
        })
        if(this.context_menu){
          this.context_menu.hideMenu()
        }
      }
    },

  watch: {
  },
  data() {
    return {
      top:0,
      msg:null,
      context_menu: null,
      conversation_key:null,
      leftRight:'',
      emojiVisible: false,
      width:0
    }
  }
}
</script>
